import { render } from "./MoreDetailsRoster7View.vue?vue&type=template&id=3e3604f3&scoped=true"
import script from "./MoreDetailsRoster7View.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster7View.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster7View.vue?vue&type=style&index=0&id=3e3604f3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3604f3"]])

export default __exports__